module.exports = "<iframe class=\"doc\" [src]=\"sanitizeImageUrl(url)\"></iframe>"